export class StatusFile {
    id: string
    payload: string
    userId: string
    progress: string
    url: any
    status: string
}
